export default "__VITE_ASSET__1eed845d__"